/**
 * Time Input Renderer
 *
 * Native HTML5 time input field
 */

import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { FieldRenderer } from '@/MyCode/core';

/**
 * Time Input Renderer
 * Features:
 * - Native time picker
 * - Min/max time constraints
 * - Step interval support
 * - Error states
 */
export const renderTimeInput: FieldRenderer = ({
    field,
    value,
    hasError,
    handleChange,
    isRequired
}) => {
    return (
        <div className="space-y-2">
            <Label htmlFor={field.name}>
                {field.label}
                {isRequired && <span className="text-destructive ml-1">*</span>}
            </Label>
            <Input
                id={field.name}
                type="time"
                value={value || ''}
                onChange={(e) => handleChange(field.name, e.target.value)}
                min={field.minValue as string}
                max={field.maxValue as string}
                step={field.step}
                className={hasError ? 'border-destructive' : ''}
            />
            {hasError && (
                <p className="text-sm text-destructive">
                    {/* Error message would be displayed here */}
                </p>
            )}
        </div>
    );
};

export default renderTimeInput;
